// eslint-disable-next-line
import { UserLayout, BasicLayout, RouteView, BlankLayout, PageView } from '@/layouts'
import { bxAnaalyse } from '@/core/icons'

export const asyncRouterMap = [

  {
    path: '/',
    name: 'index',
    component: BasicLayout,
    meta: { title: '首页' },
    redirect: '/dashboard',
    children: [
      // dashboard
      {
        path: '/dashboard',
        name: 'dashboard',
        redirect: '/dashboard/statistics',
        component: RouteView,
        meta: { title: '仪表盘', keepAlive: true, icon: bxAnaalyse, permission: [ 'dashboard' ] },
        children: [
          {
            path: '/dashboard/statistics',
            name: 'Statistics',
            component: () => import('@/views/dashboard/Statistics'),
            meta: { title: '总览', keepAlive: true, permission: [ 'dashboard' ] }
          }
        ]
      },

      // Exception
      {
        path: '/exception',
        name: 'exception',
        hidden: true,
        component: RouteView,
        redirect: '/exception/403',
        meta: { title: '异常页', icon: 'warning', permission: [ 'exception' ] },
        children: [
          {
            path: '/exception/403',
            name: 'Exception403',
            component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/403'),
            meta: { title: '403', permission: [ 'exception' ] }
          },
          {
            path: '/exception/404',
            name: 'Exception404',
            component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404'),
            meta: { title: '404', permission: [ 'exception' ] }
          },
          {
            path: '/exception/500',
            name: 'Exception500',
            component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/500'),
            meta: { title: '500', permission: [ 'exception' ] }
          }
        ]
      },

      // account
      {
        path: '/account',
        component: RouteView,
        redirect: '/account/center',
        name: 'account',
        hidden: true,
        meta: { title: '个人页', icon: 'user', keepAlive: true, permission: [ 'profile' ] },
        children: [
          {
            path: '/account/center',
            name: 'center',
            component: () => import('@/views/account/center/Index'),
            meta: { title: '个人中心', keepAlive: true, permission: [ 'profile' ] }
          },
          {
            path: '/account/settings',
            name: 'settings',
            component: () => import('@/views/account/settings/Index'),
            meta: { title: '个人设置', hideHeader: true, permission: [ 'profile' ] },
            redirect: '/account/settings/base',
            hideChildrenInMenu: true,
            children: [
              {
                path: '/account/settings/base',
                name: 'BaseSettings',
                component: () => import('@/views/account/settings/BaseSetting'),
                meta: { title: '基本设置', hidden: true, permission: [ 'profile' ] }
              },
              {
                path: '/account/settings/security',
                name: 'SecuritySettings',
                component: () => import('@/views/account/settings/Security'),
                meta: { title: '安全设置', hidden: true, keepAlive: true, permission: [ 'profile' ] }
              },
              {
                path: '/account/settings/custom',
                name: 'CustomSettings',
                component: () => import('@/views/account/settings/Custom'),
                meta: { title: '个性化设置', hidden: true, keepAlive: true, permission: [ 'profile' ] }
              },
              {
                path: '/account/settings/binding',
                name: 'BindingSettings',
                component: () => import('@/views/account/settings/Binding'),
                meta: { title: '账户绑定', hidden: true, keepAlive: true, permission: [ 'profile' ] }
              }
            ]
          }
        ]
      },

      {
        path: '/user',
        name: 'User',
        component: PageView,
        redirect: '/user/manager',
        meta: { title: '客户', icon: 'user', permission: [ 'client' ] },
        children: [
          {
            path: '/user/corp',
            name: 'Corporation',
            component: () => import('@/views/user/Corporation'),
            meta: { title: '企业管理', keepAlive: false, permission: [ 'corp' ] }
          },
          {
            path: '/user/manager',
            name: 'UserManager',
            component: () => import('@/views/user/Manager'),
            meta: { title: '用户管理', keepAlive: false, permission: [ 'user' ] }
          }
        ]
      },

      {
        path: '/device',
        name: 'Device',
        component: PageView,
        redirect: '/device/manager',
        meta: { title: '终端', icon: 'robot', permission: [ 'device' ] },
        children: [
          {
            path: '/device/manager',
            name: 'DeviceManager',
            hidden: true,
            component: () => import('@/views/device/Manager'),
            meta: { title: '终端管理', keepAlive: false, permission: [ 'device' ] }
          },
          {
            path: '/device/list',
            name: 'DeviceList',
            component: () => import('@/views/device/List'),
            meta: { title: '终端列表', keepAlive: false, permission: [ 'device' ] }
          },
          {
            path: '/device/log',
            name: 'DeviceLog',
            hidden: true,
            component: () => import('@/views/device/Log'),
            meta: { title: '更新记录', keepAlive: false, permission: [ 'device' ] }
          },
          {
            path: '/device/register',
            name: 'DeviceRegister',
            hidden: true,
            component: () => import('@/views/device/Register'),
            meta: { title: '激活', keepAlive: false, permission: [ 'device' ] }
          }
        ]
      },

      {
        path: '/file',
        name: 'File',
        component: PageView,
        hidden: true,
        redirect: '/file/manager',
        meta: { title: '文件', icon: 'folder', permission: [ 'file' ] },
        children: [
          {
            path: '/file/manager',
            name: 'FileManager',
            component: () => import(/* webpackChunkName: "result" */ '@/views/file/Manager'),
            meta: { title: '文件管理', keepAlive: false, permission: [ 'file' ] }
          }
        ]
      },

      {
        path: '/message',
        name: 'Message',
        component: PageView,
        meta: { title: '消息', icon: 'message', permission: [ 'message' ] },
        redirect: '/message/list',
        children: [
          {
            path: '/message/list',
            name: 'MessageList',
            component: () => import('@/views/message/List'),
            meta: { title: '我的消息', keepAlive: false, permission: [ 'message' ] }
          },
          {
            path: '/message/detail',
            name: 'MessageDetail',
            hidden: true,
            component: () => import('@/views/message/Detail'),
            meta: { title: '消息详情', keepAlive: false, permission: [ 'message' ] }
          }
        ]
      },

      {
        path: '/vendor',
        name: 'Vendor',
        component: PageView,
        redirect: '/vendor/overview',
        meta: { title: '第三方厂商', icon: 'android', permission: [ 'client' ] },
        children: [
          {
            path: '/vendor/overview',
            name: 'VendorOverview',
            component: () => import('@/views/vendor/VendorOverview'),
            meta: { title: '统计面板', keepAlive: false, permission: [ 'client' ] }
          },
          {
            path: '/vendor/manager',
            name: 'VendorManager',
            component: () => import('@/views/vendor/VendorManager'),
            meta: { title: '验证码管理', keepAlive: false, permission: [ 'client' ] }
          }
        ]
      },
      {
        path: '/activePlatForm',
        name: 'ActivePlatForm',
        component: PageView,
        redirect: '/vendor/overview',
        meta: { title: '激活平台', icon: 'bank' },
        children: [
          {
            path: '/activePlatForm/company',
            name: 'ActivePlatformCompany',
            component: () => import('@/views/activePlatForm/softwareCompany.vue'),
            meta: { title: '软件公司', keepAlive: false, permission: [ 'online-company' ] }
          },
          {
            path: '/activePlatForm/project',
            name: 'ActivePlatformProject',
            component: () => import('@/views/activePlatForm/projectItem.vue'),
            meta: { title: '项目列表', keepAlive: false, permission: [ 'online-first' ] }
          }
        ]
      }
    ]
  },
  {
    path: '*', redirect: '/404', hidden: true
  }
]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/user',
    component: UserLayout,
    redirect: '/user/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Login')
      },
      {
        path: 'register',
        name: 'register',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Register')
      },
      {
        path: 'register-result',
        name: 'registerResult',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/RegisterResult')
      }
    ]
  },

  {
    path: '/404',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404')
  }

]
